import Link from 'next/link';

import cx from 'classnames';
import useDynamicFontSize from 'themes/canvas/components/utils';

import { useGGTheme } from 'hooks/theme/useGGTheme';

import s from './BillboardHero.module.css';

interface HeroProps {
  imgSrc: string;
  businessName: string;
  bookNowLinkUrl: string;
}

export const BillboardHero: React.FC<HeroProps> = ({
  imgSrc,
  businessName,
  bookNowLinkUrl,
}) => {
  const { containerRef, fontSize, nowrapClass } =
    useDynamicFontSize(businessName);

  const businessNameStyle: React.CSSProperties = {
    fontSize: fontSize ? `${fontSize}px` : 'inherit',
  };

  const { themeMode, theme } = useGGTheme();

  const currentPalette =
    theme && theme.palette.name ? theme.palette.name.toLowerCase() : null;

  const isDarkMode = themeMode === 'dark';

  return (
    <section
      className={cx(
        s.root,
        {
          [s.darkMode]: isDarkMode,
        },
        currentPalette && s[currentPalette],
      )}
    >
      <div
        className={s.heroContent}
        ref={containerRef}
        style={{
          backgroundImage: `url(${imgSrc})`,
        }}
      >
        <div className={cx(s.businessName, nowrapClass ? s.nowrapClass : '')}>
          <h1 style={businessNameStyle}>{businessName}</h1>
          <Link href={bookNowLinkUrl}>Book Now</Link>
        </div>
      </div>
    </section>
  );
};
